<template>

  <div class="user">
  

    <div style="">

      
           
      <div style="float: left;width:18%;">
        <Supply_s  @handleCurrentChange="handleCurrentChangeS" ></Supply_s>
    </div>
      <div style="float: left;width:80%;margin-left: 1%;">
            <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="货运单名称">
          <el-input placeholder="请输入货运单名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>
    <div class="product-content" >
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      
            <el-table-column prop="freightBillNumber" label="货运单号"></el-table-column>
            <el-table-column prop="sender" label="发货人"></el-table-column>
            <el-table-column prop="receiver" label="收货人"></el-table-column>
            <el-table-column prop="origin" label="起点"></el-table-column>
            <el-table-column prop="destination" label="目的地"></el-table-column>
            <el-table-column prop="shipmentDate" label="发货日期"></el-table-column>
            <el-table-column prop="deliveryDate" label="交货日期"></el-table-column>
            <el-table-column prop="cargoDescription" label="货物描述"></el-table-column>
            <el-table-column prop="cargoWeight" label="货物重量"></el-table-column>
            <el-table-column prop="cargoVolume" label="货物体积"></el-table-column>
            <el-table-column prop="freightAmount" label="运费"></el-table-column>
            <el-table-column prop="paymentMethod" label="付款方式"></el-table-column>
            <el-table-column prop="shippingCompany" label="运输公司"></el-table-column>
            <el-table-column prop="trackingNumber" label="跟踪号"></el-table-column>
            <el-table-column prop="status" label="状态"></el-table-column>
            <el-table-column prop="remarks" label="备注"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>


      </div>
 
    <div style="clear: both;"></div>
    </div>
    
  
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :waybill_id="waybill_id"  v-if="open_edit"   @close="closeEdit"></Edit>


  
  </div>
</template>

<script>
  import WaybillApi from '@/api/waybill.js';
  import SupplyApi from '@/api/supply.js';
  import Supply_s from '@/components/select/supply';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
      Supply_s
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        waybill_id:"",
        dialogVisible:false,


        supply_search:"",
        supplyList:[],
        currentRow :null
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//货运单标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },
      handleCurrentChangeS(val){
        this.formInline.supply_id = val.id
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        WaybillApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.waybill_id = row.waybill_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            WaybillApi.del(
              {
                waybill_id: row.waybill_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },

    

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/waybill/index/index.vue